import { AxiosResponse } from 'axios';
import { instance as axios } from 'api/axios';

import { objToFormData } from 'utils';
import { ExistResponse, GetUserBranches } from './interfaces';

export class AADGroupService {
  static prefix = '/AADGroup';

  static secondPrefix = '/Roles';

  public static async checkExist(userId: string[]) {
    const formData = objToFormData(userId);
    try {
      const url = `${AADGroupService.prefix}/CheckExist`;
      const response: AxiosResponse<ExistResponse> = await axios.post(url, formData);

      return response.data;
    } catch (error: any) {
      throw new Error(error);
    }
  }

  public static async getUserBranches(userId?: number) {
    try {
      const url = `${AADGroupService.secondPrefix}/AvailableBranches`;
      const response: AxiosResponse<GetUserBranches[]> = await axios.get(url, { params: { id: userId } });
      return response.data;
    } catch (error: any) {
      throw new Error(error);
    }
  }
}
